module.exports = __webpack_public_path__ + "pic_bizny_web_02-375@2x.png?3654b4b73fa6127685246b1baed3c3ba";